// API URL Yapılandırması

// Backend API'nin temel URL'si
export const API_BASE_URL = 'https://saticiyz-backend.saticiyiz.workers.dev';

// API endpoint'leri için yardımcı fonksiyon
export const getApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};

// Temel API endpoint'leri
export const API_ENDPOINTS = {
  // Dashboard
  DASHBOARD: {
    STATS: '/api/dashboard/stats',
  },
  
  // Siparişler
  ORDERS: {
    LIST: '/api/orders',
    STATUS: '/api/orders/status',
  },
  
  // Ürünler
  PRODUCTS: {
    LIST: '/api/trendyol/products',
    SYNC: '/api/trendyol/sync',
    DETAILS: (barcode) => `/api/trendyol/products/details/${barcode}`,
    SETTINGS: '/api/trendyol/product-settings',
    SETTINGS_SYNC: '/api/trendyol/product-settings-sync',
    UPDATE_COSTS: '/api/trendyol/update-product-costs',
    PROFIT: '/api/trendyol/product-profit',
    FLASH: '/api/trendyol/flash-products',
    ADVANTAGE: '/api/trendyol/advantage-products',
  },
  
  // Entegrasyonlar
  INTEGRATIONS: {
    STATUS: '/api/integrations/status',
    EXPORT: '/api/integrations/export-product',
    GOOGLE_AUTH: '/api/integrations/google/auth-url',
    EMAIL_CONNECT: '/api/integrations/email/connect',
    DISCONNECT_GOOGLE: '/api/integrations/disconnect/google',
    DISCONNECT_EMAIL: '/api/integrations/disconnect/email',
  },
  
  // Kullanıcı ve Ayarlar
  USERS: {
    LOGIN: '/users/login',
    REGISTER: '/users/register',
    PROFILE: '/users/profile',
  },
  
  SETTINGS: {
    PROFILE: '/settings/profile',
    API: '/settings/api',
    API_SETTINGS: '/settings/api-settings',
  },
}; 